// directives/text.js
export const text = {
    selector: '[data-text]',
    reactive: true,
    run(el, data, root) { 
        const key = el.getAttribute('data-text');
        if (data[key] !== undefined) {
            el.textContent = data[key];
        }

        if (!root.__bindings) root.__bindings = {};
        if (!root.__bindings[key]) root.__bindings[key] = [];
        root.__bindings[key].push((newVal) => {
            el.textContent = newVal;
        });
    }
};